import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";

const ViewBookingModal = ({ modal, setModal, item }) => {
	const lang = useSelector((state) => state.auth.lang);

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<Modal.Body>
				<Row>
					<Col md={12} className="mb-2">
						<div className="d-flex justify-content-between">
							<p
								className="mb-0 text-black fw-bold"
								style={{
									fontSize: "20px",
								}}>
								{Translate[lang]?.view} {Translate[lang]?.booking}
							</p>
							<Button
								variant=""
								className="close"
								style={{
									right: lang === "en" ? "0" : "auto",
									left: lang === "ar" ? "0" : "auto",
								}}
								onClick={() => {
									setModal();
								}}>
								<span style={{ fontSize: "22px" }}>&times;</span>
							</Button>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].government}:</label>
							<p className="mb-0">{item?.governorate[`name_${lang}`]}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].area}:</label>
							<p className="mb-0">{item?.area[`name_${lang}`]}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].location}:</label>
							<p className="mb-0">{item?.location_on_map}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].full_address}:</label>
							<p className="mb-0">{item?.full_address}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].date}:</label>
							<p className="mb-0">{item?.date?.split("T")[0]}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].time}:</label>
							<p className="mb-0">{item?.time}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].package}:</label>
							<p className="mb-0">{item?.package[`name_${lang}`]}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].payment}:</label>
							<p className="mb-0">{item?.payment_status}</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].price}:</label>
							<p className="mb-0">
								{item?.price} {Translate[lang].kwd}
							</p>
						</div>
					</Col>
					<Col md={6} className="mb-3">
						<div>
							<label>{Translate[lang].total_price}:</label>
							<p className="mb-0">
								{item?.price} {Translate[lang].kwd}
							</p>
						</div>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="danger" type="submit" className="w-100">
					{Translate[lang]?.close}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default ViewBookingModal;
